import { createFontStyles, getLanguage, IFontStyles } from "@fluentui/react";
import { M365ActualLightTheme } from "@m365-admin/customizations";
import { PartialPalette, PartialSemanticColors, PartialTheme, twoUIPaletteColors } from "../types";

// snapshotted on 2/25/2020 from https://www.figma.com/file/X2w9NdiyCKVvZwLYv8nnQ2/AMC-Fabric-POR?node-id=159%3A0
export const amcPalette: PartialPalette & { [K in typeof twoUIPaletteColors[number]]: string } = {
    themePrimary: "#006fc9",
    themeLighterAlt: "#f3f8fd",
    themeLighter: "#cfe5f6",
    themeLight: "#a7cfef",
    themeTertiary: "#59a3df",
    themeSecondary: "#197ed0",
    themeDarkAlt: "#0064b5",
    themeDark: "#005499",
    themeDarker: "#003e71",
    neutralLighterAlt: "#ececec",
    neutralLighter: "#e8e8e8",
    neutralLight: "#dedede",
    neutralQuaternary: "#c6c6c6",
    neutralQuaternaryAlt: "#cfcfcf",
    neutralTertiary: "#a19f9d",
    neutralTertiaryAlt: "#bebebe",
    neutralSecondary: "#605e5c",
    neutralPrimaryAlt: "#3b3a39",
    neutralPrimary: "#323130",
    neutralDark: "#201f1e",
    neutralMed: "#fafafa",
    neutralHigh: "#ffffff",
    transparent: "transparent",
    black: "#000000",
    white: "#f2f2f2",
    redDark: "#a4262c",
    redLight: "#feece5",
    highlighter: "#f8d22a"
};

export const amcSemanticColors: PartialSemanticColors = {
    bodyBackground: amcPalette.white,
    navBackground: amcPalette.white,
    navItemBackgroundHovered: amcPalette.neutralLighter,
    navItemBackgroundPressed: amcPalette.neutralLight,
    severeWarning: "#fed9cc",
    errorBlockIcon: "#a80000",
    messageLink: amcPalette.themeDarkAlt,
    messageWebSuccess: "#107c10",
    warningIcon: "#901619",
    severeWarningIcon: "#790C0E",
    buttonBackground: amcPalette.neutralHigh,
    cautionYellow: "#9D5D00"
};

/** This retrieves the default font family with fallback generated from FluentUI. Segoe UI will be the first fallback. */
const fluentFontStyles = createFontStyles(getLanguage() || navigator.language);

export const amcFonts: Partial<IFontStyles> = {
    // Small is for font sizes smaller than 13px
    small: {
        font: `Segoe UI Variable Small, ${fluentFontStyles.medium.fontFamily}`
    },
    // Text is for font sizes 13px to 24px
    medium: {
        font: `Segoe UI Variable Text, ${fluentFontStyles.medium.fontFamily}`
    },
    // Display is for font sizes larger than 24px
    large: {
        font: `Segoe UI Variable Display, ${fluentFontStyles.medium.fontFamily}`
    }
};

export const amcDefaultFontStyle = {
    fontFamily: amcFonts.medium!.font
};

export const amcTheme: PartialTheme = {
    palette: amcPalette,
    semanticColors: amcSemanticColors
};

export const amcLeftNavTheme: PartialTheme = {
    palette: amcPalette,
    semanticColors: {
        ...M365ActualLightTheme,
        ...amcSemanticColors
    }
};
